import Typography from '@mui/material/Typography';
import { Box, Divider } from '@mui/material';
import { SharedCard } from '../../../../components/shared-card/card';
import ProfileForm from './profileForm';
import EditableField from './EditableField';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { useTranslation } from 'react-i18next';

export default function KYCBankDetailsPage({ user }) {
  const { t } = useTranslation();

  console.log(user);

  return (
    <ProfileForm>
      {(isEditable) => (
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h4">
            {t('user_profile.kyc_and_bank.header')}
          </Typography>

          <SharedCard>
            <Typography variant="h5" gutterBottom>
              {t('user_profile.kyc_and_bank.kyc_verification.label')}
            </Typography>

            <Box display="flex" gap={1}>
              <Box width="100%">
                <Typography variant="h6">
                  {t('kyc.proof_of_identity')}
                </Typography>
                <Typography
                    fontWeight="bold"
                    color="textSecondary"
                >
                  {t('kyc.pan')}
                </Typography>

                <Box
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <DoneAllIcon color="primary"></DoneAllIcon>
                  <Typography color="primary">{t('verified')}</Typography>
                </Box>
              </Box>
              <Divider orientation="vertical" />
              <Box width="100%">
                <Typography variant="h6">
                  {t('kyc.proof_of_address')}
                </Typography>

                  <Typography
                    fontWeight="bold"
                    color="textSecondary"
                  >
                    {t('kyc.aadhaar')}
                  </Typography>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <DoneAllIcon color="primary"></DoneAllIcon>
                    <Typography color="primary">{t('verified')}</Typography>
                  </Box>
              </Box>
            </Box>
          </SharedCard>

          <SharedCard>
            <Typography variant="h5" gutterBottom>
              {t('user_profile.kyc_and_bank.bank_details.label')}
            </Typography>

            <Box display="flex" gap={1}>
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                width="100%"
              >
                <Box>
                  <EditableField
                    label={t('awaiting_account_details.bank_name')}
                    value={user.user_profile.user_account?.bank_name || '-'}
                    isEditable={isEditable}
                  />
                </Box>

                <Box>
                  <EditableField
                    label={t('awaiting_account_details.account_holder_name')}
                    value={user.user_profile.user_account?.account_holder_name || '-'}
                    isEditable={isEditable}
                  />
                </Box>
              </Box>

              <Divider orientation="vertical" />

              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                width="100%"
              >
                <Box>
                  <EditableField
                    label={t('awaiting_account_details.ifsc_code')}
                    value={user.user_profile.user_account?.ifsc || '-'}
                    isEditable={isEditable}
                  />
                </Box>

                <Box>
                  <EditableField
                    label={t('awaiting_account_details.account_number')}
                    value={user.user_profile.user_account?.account_number || '-'}
                    isEditable={isEditable}
                  />
                </Box>
              </Box>
            </Box>
          </SharedCard>
        </Box>
      )}
    </ProfileForm>
  );
}
